import { Routes } from '@angular/router';
import {
  GeaMesLoginComponent,
  GeaMesCognitoAuthGuard,
  GeaMesAccessDeniedComponent,
  GeaMesLogoutComponent
} from '@gea-mes/cognito';

import { BoardComponent } from './board/board.component';
import { TeamWorkComponent } from './work/team-work.component';
import { TeamSelect } from './nav/team-select/team-select.component';
import { CanDeactivateGuard } from './work/services/can-deactivate-guard.service';
import { TeamSelectMultiComponent } from './nav/team-select-multi/team-select-multi.component';
import { MultiTeamWorkComponent } from './multi-team/multi-team-work/multi-team-work.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: GeaMesLogoutComponent },
  { path: 'accessdenied', component: GeaMesAccessDeniedComponent },
  {
    path: '',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: '', redirectTo: '/plants', pathMatch: 'full' },
      { path: 'board', component: BoardComponent },
      { path: 'plants', component: TeamSelect },
      { path: 'plants/:plant_name', component: TeamSelect },
      { path: 'plants/:plant_name/:line', component: TeamSelect },
      { path: 'plants/:plant_name/:line/:subline', component: TeamSelect },
      { path: 'lines/:plant_name', component: TeamSelect },
      { path: 'viewteams', component: TeamSelectMultiComponent },
      { path: 'viewteams/:plant_name/:line/:subline', component: TeamSelectMultiComponent },
      { path: 'teamview', component: TeamSelect },
      { path: 'teamwork/:plant_name/:line/:team/:version', component: TeamWorkComponent, canDeactivate: [CanDeactivateGuard] },
      { path: 'teamwork/:plant_name/:line/:subline/:team/:version', component: TeamWorkComponent, canDeactivate: [CanDeactivateGuard] },
      { path: 'multiteamwork', component: MultiTeamWorkComponent }
    ]
  },
  { path: '**', redirectTo: '/plants' }
];